var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { classNames } from '@progress/kendo-react-common';
/**
 * Returns the action bar of the Dialog.
 *
 * @returns React.ReactElement
 */
export var DialogActionsBar = function (props) {
    var _a;
    var combinedProps = __assign({ layout: 'stretched' }, props);
    var layout = combinedProps.layout, children = combinedProps.children;
    var wrapperClasses = classNames('k-actions', 'k-actions-horizontal', 'k-window-actions k-dialog-actions', (_a = {},
        _a["k-actions-".concat(layout)] = layout,
        _a));
    return (React.createElement("div", { className: wrapperClasses }, children));
};
DialogActionsBar.propTypes = {
    children: PropTypes.any,
    layout: PropTypes.oneOf(['start', 'center', 'end', 'stretched'])
};
